import React, { useState, useRef } from 'react';
import Form from 'react-bootstrap/Form';

import "./nefSubmission.css";
import { AI_ROBOT } from '../../../constant';
import InputField from '../../commanComponents/inputField/inputField';
import BaseNavbar from '../../commanComponents/navbar/baseNavbar';
import PrimaryButton from '../../commanComponents/primaryButton/primaryButton';
import { validateDate, validateURL } from '../../../utils/validations';
import { getNefSubmissionVerifyService, getNefSubmissionService, getUploadFileUrlService } from '../../../modules/services';
import UploadField from '../../commanComponents/uploadInputField/uploadField';


const NEFestSubmissions = () => {

    const projectPDFRef = useRef();
    const [isLoading, setIsLoading] = useState(false);
    const [competitionFormSubmitted, setCompetitionFormSubmitted] = useState(false);
    const [competitionInvalid, setCompetitionInvalid] = useState({ isError: false, errorMessage: "" });
    const [GuardianNameInvalid, setGuardianNameInvalid] = useState({ isError: false, errorMessage: "" });
    const [projectPDFInvalid, setProjectPDFInvalid] = useState({ isError: false, errorMessage: ""});
    const [competitionData, setCompetitionData] = useState({ competition_id: "", id: "" });
    const [submissionData, setsubmissionData] = useState({ submission_guardian_name: "", submission_project_pdf: "" });
    
    const handleCompetitionIdChange = (competitionId) => {
        setCompetitionData({ ...competitionData, competition_id: competitionId });
        var errorMessage = validateDate(competitionId);
        var isError;
        if (errorMessage === "") {
            setCompetitionInvalid({ isError: false, errorMessage: "" });
            isError = false;
        }
        else {
            setCompetitionInvalid({ isError: true, errorMessage: errorMessage });
            isError = true;
        }
        return isError;
    }

    const handleGuardianNameChange = (guardianName) => {
        setsubmissionData({ ...submissionData, submission_guardian_name: guardianName });
        var errorMessage = validateDate(guardianName);
        var isError;
        if (errorMessage === "") {
            setGuardianNameInvalid({ isError: false, errorMessage: "" });
            isError = false;
        }
        else {
            setGuardianNameInvalid({ isError: true, errorMessage: errorMessage });
            isError = true;
        }
        return isError;
    }

    const uploadProjectPDF = (file, fileExtension) => { 
        const imageName = "nef_25/submissions/" + competitionData.competition_id.replaceAll("/", "-") + "." + fileExtension;
        
        (async () => {
            const responseData = await getUploadFileUrlService({"media_key": imageName, content_type: "application/pdf" }, {});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {

                fetch(responseData.data.signed_url, {
                    method: "PUT",
                    body: file,
                }).then(
                    (async () => {
                        const responseData = await getNefSubmissionService(competitionData.id,
                            { ...submissionData, submission_project_pdf: imageName }
                            , {});
                        if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                            setIsLoading(false);
                            setTimeout(() => {
                                window.location.href = "https://fizrobotics.com/";
                              }, 3000);
                        }
                        else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                            setIsLoading(false);
                        }
                        else {
                            window.location.href = "https://fizrobotics.com/";
                        }
                    })()
                )
                
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                window.location.href = "https://fizrobotics.com/";
            }
        })();
    }


    const handleProjectPDFChange = (videoURL) => {
        var isError;

        if (typeof (videoURL) == "string") {
            if (videoURL === "") {
                setProjectPDFInvalid({ isError: true, errorMessage: "This field is required." });
                isError = true;
            }
            else if (["pdf"].indexOf(videoURL.split(".")[1]) < 0) {
                setProjectPDFInvalid({ isError: true, errorMessage: "Only PDF is allowed as a profile picture." });
                isError = true;
            }
            else {
                setProjectPDFInvalid({ isError: false, errorMessage: "" });
                isError = false;
            }
        }
        else {
            const file = videoURL.target.files[0];
            
            if (file) { 
                const fileExtension = file.name.split(".")[1];
                if (["pdf"].indexOf(fileExtension) < 0) { 
                    setProjectPDFInvalid({ isError: true, errorMessage: "Only PDF is allowed to be submitted." });
                    projectPDFRef.current.value = null;
                    isError = true;
                }
                else if (file.size > 5000000) {
                    setProjectPDFInvalid({ isError: true, errorMessage: "PDF size should not be greater than 5MB." });
                    projectPDFRef.current.value = null;
                    isError = true;
                }
                else {
                    setsubmissionData({ ...submissionData, submission_project_pdf: file.name });
                    setProjectPDFInvalid({ isError: false, errorMessage: "" });
                    isError = false;
                }
            }
            else {
                setProjectPDFInvalid({ isError: true, errorMessage: "This field is required." });
                isError = true;
            }
            return isError;
        }
    }

    const handleSubmission = (event) => {
        event.preventDefault();

        const isGuardianNameError = handleGuardianNameChange(submissionData.submission_guardian_name);
        const isProjectPDFError = handleProjectPDFChange(submissionData.submission_project_pdf);

        if (!isGuardianNameError && !isProjectPDFError) { 
            uploadProjectPDF(projectPDFRef.current.files[0], submissionData.submission_project_pdf.split(".")[1]);
        }
    }

    const handleCompetetionSubmission = (event) => {
        event.preventDefault();

        const isCompetitionIdError = handleCompetitionIdChange(competitionData.competition_id);
        if (!isCompetitionIdError) { 
            (async () => {
                const responseData = await getNefSubmissionVerifyService(competitionData, {});
                if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                    setIsLoading(false);
                    setCompetitionFormSubmitted(true);
                    setCompetitionData({ ...competitionData, id: responseData.data.id });
                }
                else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                    console.log(responseData);
                }
                else {
                    window.location.href = "https://fizrobotics.com/";
                }
            })();
        }

    }


    return (
        <>
            <BaseNavbar />
            <div className='row main-row'>
                <div className='col left-img-div'>
                    <img
                        src={AI_ROBOT}
                        alt='ai_robot'
                        className='ai_robot_img'
                    />
                </div>
                <div className='col'>
                    <div className='nef-main-div'>
                        <div className='nef-form-div'>
                            <Form noValidate>
                                <Form.Label className='heading'>
                                    N.E.F. Presentation Submission
                                </Form.Label>
                                <Form.Label className='sub-heading'>
                                    Welcome to 
                                    <br/>National Entrepreneurship Fest 2.0 Portal
                                </Form.Label>
                                {
                                    competitionFormSubmitted ?
                                        <>
                                            <InputField
                                                iconClass="bi-person-fill"
                                                placeholder="Guardian Name"
                                                fieldType="text"
                                                isInvalid={GuardianNameInvalid.isError}
                                                onChange={handleGuardianNameChange}
                                                errorMessage={GuardianNameInvalid.errorMessage}
                                                value={submissionData.submission_guardian_name}
                                                inputKey="nef_guardian_name"
                                            />
                                            <br />
                                            <UploadField
                                                iconClass="bi-cloud-arrow-up-fill"
                                                isInvalid={projectPDFInvalid.isError}
                                                onChange={handleProjectPDFChange}
                                                uploadRef={projectPDFRef}
                                                errorMessage={projectPDFInvalid.errorMessage}
                                                inputKey="nef_project_pdf"
                                                descriptionMessage="Upload your Project PDF here."
                                            />
                                            <br />

                                            <div className='submit-button-div'>
                                                <PrimaryButton
                                                    text="SUBMIT"
                                                    isLoading={isLoading}
                                                    onClick={handleSubmission}
                                                    customStyle={{height: "40px"}}
                                                />
                                            </div>
                                        </>
                                        :
                                        <>
                                            <InputField
                                                iconClass="bi-bar-chart-line-fill"
                                                placeholder="Competition ID (NEF/2025/01212)"
                                                fieldType="text"
                                                isInvalid={competitionInvalid.isError}
                                                onChange={handleCompetitionIdChange}
                                                errorMessage={competitionInvalid.errorMessage}
                                                value={competitionData.competition_id}
                                                descriptionMessage="The competition ID has been sent to your registered email ID."
                                                inputKey="nef_competition_id"
                                            />
                                            <br />

                                            <div className='submit-button-div'>
                                                <PrimaryButton
                                                    text="VERIFY"
                                                    isLoading={isLoading}
                                                    onClick={handleCompetetionSubmission}
                                                    customStyle={{height: "40px"}}
                                                />
                                            </div>
                                        </>
                                }
                                <Form.Label className='nef-bottom-description'>
                                    <b>Note:</b> In case of any query, feel free to contact contact@fizrobotics.com
                                </Form.Label>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default NEFestSubmissions;
